import React from "react";

const Alert=(props)=>(
    <div className="alert">
        <span>{props.titleError}</span>
        <span>{props.contentError}</span>
    </div>
)
export default Alert;